import type { LineupPlayer } from '../components';
import type { LineupTabResponse } from '../types';

export const MOCK_4_LINES: LineupPlayer[][] = [
  [{ name: 'Striker 1', goals: 3 }, { name: 'Striker 2' }],
  [
    { name: 'Midfielder 1', assists: 10 },
    { name: 'Midfielder 2' },
    { name: 'Midfielder 3', goals: 4 },
    { name: 'Midfielder 4' },
  ],
  [{ name: 'Defender 1' }, { name: 'Defender 2' }, { name: 'Defender 3' }, { name: 'Defender 4' }],
  [{ name: 'Goalkeeper' }],
];

export const MOCK_5_LINES: LineupPlayer[][] = [
  [{ name: 'Striker 1', goals: 10 }],
  [
    { name: 'Midfielder 1', assists: 10 },
    { name: 'Midfielder 2' },
    { name: 'Midfielder 3', goals: 4 },
  ],
  [
    { name: 'Midfielder 4', assists: 5 },
    { name: 'Midfielder 5', goals: 3, assists: 3 },
    { name: 'Midfielder 6' },
  ],
  [{ name: 'Defender 1', assists: 1 }, { name: 'Defender 2' }, { name: 'Defender 3', goals: 2 }],
  [{ name: 'Goalkeeper' }],
];

export const LINEUP_MOCK_DATA: LineupTabResponse = {
  home: {
    lines: [
      [
        {
          name: 'Striker 1',
          goals: 3,
          assists: 0,
        },
        { name: 'Striker 2', goals: 0, assists: 0 },
      ],
      [
        { name: 'Midfielder 1', goals: 0, assists: 10 },
        { name: 'Midfielder 2', goals: 0, assists: 0 },
        { name: 'Midfielder 3', goals: 4, assists: 0 },
        { name: 'Midfielder 4', goals: 0, assists: 0 },
      ],
      [
        { name: 'Defender 1', goals: 0, assists: 0 },
        { name: 'Defender 2', goals: 0, assists: 0 },
        { name: 'Defender 3', goals: 0, assists: 0 },
        { name: 'Defender 4', goals: 0, assists: 0 },
      ],
      [{ name: 'Goalkeeper', goals: 0, assists: 0 }],
    ],
    bench: [
      { name: 'Substitue 1', goals: 0, assists: 1 },
      { name: 'Substitue 2', goals: 0, assists: 1 },
      { name: 'Substitue 3', goals: 1, assists: 0 },
      { name: 'Substitue 4', goals: 1, assists: 0 },
      { name: 'Substitue 5', goals: 0, assists: 1 },
      { name: 'Substitue 6', goals: 0, assists: 3 },
      { name: 'Substitue 7', goals: 11, assists: 0 },
      { name: 'Substitue 8', goals: 0, assists: 0 },
    ],
  },
  away: {
    lines: [
      [
        {
          name: 'Striker 1',
          goals: 12,
          assists: 0,
        },
      ],
      [
        { name: 'Midfielder 1', goals: 7, assists: 10 },
        { name: 'Midfielder 2', goals: 1, assists: 5 },
      ],
      [
        { name: 'Midfielder 3', goals: 1, assists: 0 },
        { name: 'Midfielder 4', goals: 0, assists: 2 },
      ],
      [
        { name: 'Defender 1', goals: 0, assists: 3 },
        { name: 'Defender 2', goals: 0, assists: 0 },
        { name: 'Defender 3', goals: 1, assists: 0 },
        { name: 'Defender 4', goals: 0, assists: 2 },
        { name: 'Defender 5', goals: 0, assists: 0 },
      ],
      [{ name: 'Goalkeeper', goals: 0, assists: 1 }],
    ],
    bench: [
      { name: 'Substitue 1', goals: 3, assists: 1 },
      { name: 'Substitue 2', goals: 0, assists: 1 },
      { name: 'Substitue 3', goals: 1, assists: 0 },
      { name: 'Substitue 4', goals: 2, assists: 0 },
      { name: 'Substitue 5', goals: 0, assists: 4 },
      { name: 'Substitue 6', goals: 0, assists: 6 },
      { name: 'Substitue 7', goals: 1, assists: 0 },
      { name: 'Substitue 8', goals: 0, assists: 0 },
    ],
  },
};
